import React, { use, useEffect, useState } from 'react';

// material-ui
import { Box, Button, Card, Grid, FormControlLabel, Checkbox } from '@mui/material';

// project imports
import { TCInput } from 'components/TopCourtComponents/Input/TopCourtInput';
import { TCLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';
import { createTerm, getTerm, updateTerm } from 'services/termServices';
import { getParamsFromURL } from 'helper/Params';
import { orderTypeOption } from 'constant/constant';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import ReactQuill from 'react-quill';
import AddAssignmentComponent from './components/addAssignmentComponent';
import { splitString } from 'helper/String'

export default function AddTerm({
    merchantId, placeId
}) {

    const [form, setForm] = useState({
        title: '',
        content: '',
        isDefault: false,
        assignments: [],
        merchantId: ''
    })
    const [joiForm, setJoiForm] = useState({
        title: null,
        content: null,
    })

    const navigate = useNavigate()

    useEffect(() => {
        let { params } = getParamsFromURL(window);
        if (params) getTermDetail(params)
    }, [])

    useEffect(() => {
        setJoiForm({
            title: form.title ? null : ' required',
            content: form.content ? null : ' required',
        })
    }, [form])

    const disabledForm = () => {
        return joiForm.title || joiForm.content
    }

    const onChange = (e) => {
        setForm(prev => ({
            ...prev,
            ...e
        }))
    }

    const setAssignment = (e) => {
        if (e) {
            setForm(prev => ({
                ...prev,
                ...e,
            }))
        }
    }

    const getTermDetail = async (id) => {
        try {
            let { data, error } = await getTerm(id)
            if (error) throw error
            if (data) {
                let orderType = orderTypeOption.find((item) => item.value === data.orderType)
                let category = {
                    label: data.categoryId ? data.categoryId.name : '',
                    value: data.categoryId ? data.categoryId._id : ''
                }
                let assignments = []

                for (let i = 0; i < data.assignments.length; i++) {
                    const item = data.assignments[i];
                    assignments[i] = {
                        _id: item._id,
                        categoryId: item.categoryId ? item.categoryId : '',
                        categorySelected: item.categoryId ? { 'label': splitString(item.categoryName, '_', ' '), 'value': item.categoryId } : '',
                        orderType: item.orderType ? item.orderType : '',
                        orderTypeSelected: item.orderType ? { 'label': splitString(item.orderType, '_', ' '), 'value': item.orderType } : '',
                        isDeleted: false,
                    }
                }
                setForm({
                    ...data,
                    assignments: assignments,
                    orderType: orderType,
                    categoryId: category
                })
            }
        } catch (error) {
            console.log(error)
        }
    }

    const updateOrCreate = () => {
        if (form._id) {
            update()
        } else {
            create()
        }
    }

    const create = async () => {
        try {
            let body = { ...form, merchantId: merchantId, placeId: placeId }
            let { data, error } = await createTerm(body)
            if (error) throw error
            if (data) {
                setForm(data)
                toast('Add Term And Condition success', {
                    toastId: "category-success",
                    type: "success"
                });
                if (!merchantId) { navigate('/term-and-conditions') }
                else {
                    window.location.reload()
                }
                // navigate('/term-and-conditions')
            }
        } catch (error) {
            console.log(error)
        }
    }

    const update = async () => {
        try {
            let body = { ...form }
            if (form.orderType === 'service') {
                body.categoryId = form.categoryId
            } else {
                body.categoryId = null
            }
            let { data, error } = await updateTerm(body)
            if (error) throw error
            if (data) {
                getTermDetail(data._id)
                toast('Update Term And Condition success', {
                    toastId: "category-success",
                    type: "success"
                });
                // navigate('/term-and-conditions')
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        console.log(form)
    }, [form])

    const handleIsDefault = () => (e) => {
        setForm(prev => ({
            ...prev,
            isDefault: e.target.checked
        }))
    }

    return (
        <>
            <Grid item container xs={12} md={12} lg={12}>
                <Grid xs={12} md={12} lg={12} sx={{ p: 1 }}>
                    <Card sx={{ mb: 3 }}>
                        <Box sx={{
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: 3
                        }}
                        >
                            <Grid container sx={{
                                p: 2
                            }}>
                                <Grid xs={12} md={12} sx={{ p: 1 }}>
                                    <TCInput value={form.title} label={"Title*"}
                                        showAlert={joiForm && joiForm.title} onChange={(e) => onChange({ title: e.currentTarget.value.trimStart() })} />
                                </Grid>
                                <Grid xs={12} md={12} sx={{ p: 1, mb: 8 }}>
                                    <TCLabel style={{ fontSize: 13, color: "rgb(133, 133, 133)" }}>Description*</TCLabel>
                                    <ReactQuill
                                        theme="snow"
                                        value={form.content}
                                        onChange={(e) => onChange({ content: e })}
                                        modules={{
                                            toolbar: [
                                                [{ 'header': [1, 2, false] }],
                                                ['bold', 'italic', 'underline'],
                                                ['link', 'image'],
                                                ['clean'],
                                                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                                [{ 'align': [] }],
                                                [{ 'color': [] }, { 'background': [] }],
                                                ['code-block'],
                                                ['blockquote'],
                                            ]
                                        }}
                                        style={{ height: 200 }}
                                    />
                                </Grid>
                                <Box style={{ width: '100%', paddingLeft: 8, paddingRight: 8 }}>
                                    <AddAssignmentComponent setAssignment={setAssignment} assignmentData={form.assignments} isDefault={handleIsDefault} formId={form._id} merchantId={merchantId} />
                                </Box>
                            </Grid>
                            <Grid container direction={"row"} sx={{
                                pl: 3
                            }}>
                                <Button
                                    variant="contained"
                                    onClick={() => { updateOrCreate() }}
                                    disabled={disabledForm()}
                                >
                                    {form._id ? "Update" : "Add"}
                                </Button>
                            </Grid>
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </>
    )
}